import { render, staticRenderFns } from "./PeriodicalManage.vue?vue&type=template&id=40076eb4&scoped=true&"
import script from "./PeriodicalManage.vue?vue&type=script&lang=js&"
export * from "./PeriodicalManage.vue?vue&type=script&lang=js&"
import style0 from "./PeriodicalManage.vue?vue&type=style&index=0&id=40076eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40076eb4",
  null
  
)

export default component.exports